import { Typography } from "@mui/material";
import React from "react";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";

const TimeSlot = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => (
  <React.Fragment>
    <Typography
      sx={{
        fontWeight: "bold",
      }}
      variant="caption"
      component="p"
    >
      Zeitraum
    </Typography>
    <Typography variant="body1" component="p">
      {`${appointment.timeSlot} Uhr`}
    </Typography>
  </React.Fragment>
);

export default TimeSlot;
